<template>
	<div class="container">
		<el-row style="height: 100%;position: relative;">
			<el-switch v-model="showresignation" active-text="显示离职" inactive-text="" >
			</el-switch>
			<el-select @change="stafselectchange" filterable v-model="selectstaff" placeholder="下拉框搜索" size="small"
				style="margin: 6px 0px;">
				<el-option-group label="快捷搜索">
					<el-option label="当前账号" :value="-1"></el-option>
				</el-option-group>
				<el-option-group label="全部">
					<el-option v-for="(item,index) in sourceStaff" :key="index"
						:label="item.name + '（'+getdepartment(item.departmentid)+'）'" :value="item.id">
					</el-option>
				</el-option-group>
			</el-select>
			<el-col :span="10" style="height: 100%;position: relative;">
				<div class="full">
					<div class="left_container full">
						<el-tabs tab-position="left" style="height: 360px;" v-model="topListActiveName">
							<el-tab-pane label="部门" name="department" style="height: 360px;overflow: auto;">
								<department-tree ref="authstaffdepartmenttree" @select="departmentTreeChange" />
							</el-tab-pane>
							<el-tab-pane label="岗位" name="postjob" v-if="postjob.length!=0"
								style="height: 360px;overflow: auto;">
								<div class="top_list_container">
									<div class="top_list" :class="{top_list_active:postjobitem.active}"
										v-for="(postjobitem,postjobindex) in postjob" :key="postjobindex"
										@click="topListItemClick(postjobitem,postjobindex,$event)">
										{{postjobitem.name}}
									</div>
								</div>
							</el-tab-pane>
							<el-tab-pane label="职务" name="joblevel" v-if="joblevel.length!=0"
								style="height: 360px;overflow: auto;">
								<div class="top_list_container">
									<div class="top_list" :class="{top_list_active:joblevelitem.active}"
										v-for="(joblevelitem,joblevelindex) in joblevel" :key="joblevelindex"
										@click="topListItemClick(joblevelitem,joblevelindex,$event)">
										{{joblevelitem.name}}
									</div>
								</div>
							</el-tab-pane>
							<el-tab-pane label="分组" name="group" v-if="group.length!=0"
								style="height: 360px;overflow: auto;">
								<div class="top_list_container">
									<div class="top_list" :class="{top_list_active:groupitem.active}"
										v-for="(groupitem,groupindex) in group" :key="groupindex"
										@click="topListItemClick(groupitem,groupindex,$event)">
										{{groupitem.name}}
									</div>
								</div>
							</el-tab-pane>
							<!-- <el-tab-pane label="离职" name="resignation" style="height: 360px;overflow: auto;"></el-tab-pane> -->
						</el-tabs>
						<!-- 						<div class="title flex">部门列表</div>
						<div class="list" style="border-bottom: 1px solid #d7dae2;height: 360px;">
							<department-tree ref="authstaffdepartmenttree" @select="departmentTreeChange" />
						</div> -->
						<div class="title flex">
							<span v-if="topListActiveName=='department'">部门人员</span>
							<span v-if="topListActiveName=='postjob'">岗位人员</span>
							<span v-if="topListActiveName=='joblevel'">职务级别人员</span>
							<span v-if="topListActiveName=='group'">分组人员</span>
							<!-- <span v-if="topListActiveName=='resignation'">离职人员</span> -->
						</div>
						<div class="list" style="height: 196px;">
							<div class="full" style="box-sizing: border-box;padding: 5px;" @click="clearStaff">
								<div @click="staffItemClick(item,index,$event)" @dblclick="toRight" class="staff"
									:class="{staff_active:item.active}" v-for="(item,index) in staff" :key="index">
									{{item.name}}
								</div>
							</div>
							<transition name="el-fade-in-linear">
								<div class="full flex form_loading" v-if="staffloading"
									style="background-color: rgba(255, 255, 255, .5);z-index: 999;color: #409EFF;">
									<i class="vxe-icon-refresh roll"></i>
									<span></span>
								</div>
							</transition>
						</div>
					</div>
				</div>
			</el-col>
			<el-col :span="4" style="height: 100%;position: relative;">
				<div class="middle flex">
					<div>
						<el-button style="width: 50px;height: 50px;" type="primary" icon="el-icon-arrow-right" circle
							@click="toRight"></el-button>
					</div>
					<div style="margin-top: 50px;">
						<el-button style="width: 50px;height: 50px;" type="primary" icon="el-icon-arrow-left" circle
							@click="toLeft"></el-button>
					</div>
				</div>
			</el-col>
			<el-col :span="10" style="height: 100%;position: relative;">
				<div class="full">
					<div class="right_container full">
						<div class="title flex">
							<div>当前选择</div>
							<el-button icon="el-icon-refresh-left" style="margin-left: 10px;" circle size="mini"
								@click="flashAuthList"></el-button>
							<el-button icon="el-icon-delete" style="margin-left: 10px;" circle size="mini"
								@click="clearselectstaff"></el-button>
						</div>
						<div class="list" style="height: 550px;">
							<div class="full" style="box-sizing: border-box;padding: 5px;" @click="clearDataItem">
								<div @click="dataItemClick(item,index,$event)" @dblclick="toLeft" class="data"
									:class="{data_active:item.active}" v-for="(item,index) in data" :key="index">
									{{item.name+'（'+item.departmentname+'）'}}
								</div>
							</div>
							<transition name="el-fade-in-linear">
								<div class="full flex form_loading" v-if="staffloading"
									style="background-color: rgba(255, 255, 255, .5);z-index: 999;color: #409EFF;">
									<i class="vxe-icon-refresh roll"></i>
									<span></span>
								</div>
							</transition>
						</div>
					</div>
				</div>
			</el-col>
		</el-row>
	</div>

</template>
<style scoped>
	.container {
		position: relative;
		width: 100%;
		height: 600px;
	}

	.middle {
		height: 100%;
		flex-direction: column;
		justify-content: center;
		align-items: center;
	}

	.left_container {
		box-sizing: border-box;
		border: 1px solid #d7dae2;
	}

	.right_container {
		box-sizing: border-box;
		border: 1px solid #d7dae2;
	}

	.title {
		position: relative;
		width: 100%;
		height: 40px;
		flex-direction: row;
		align-items: center;
		justify-content: center;
		font-size: 18px;

		background: rgb(244, 244, 245);
		border-bottom: 1px solid #d7dae2;
	}

	.list {
		position: relative;
		width: 100%;
		height: 410px;
		overflow: auto;
	}

	.staff {
		cursor: pointer;
		user-select: none;
		-webkit-user-select: none;
		-moz-user-select: none;
		-o-user-select: none;
		-ms-user-select: none;
		-webkit-touch-callout: none;
		font-size: 14px;
		box-sizing: border-box;
		padding: 0px 4px;
	}

	.staff_active {
		background-color: #409EFF;
		color: white;
	}

	.data {
		cursor: pointer;
		user-select: none;
		-webkit-user-select: none;
		-moz-user-select: none;
		-o-user-select: none;
		-ms-user-select: none;
		-webkit-touch-callout: none;
		font-size: 14px;
	}

	.data_active {
		background-color: #409EFF;
		color: white;
	}

	.top_list_container {
		font-size: 14px;
		box-sizing: border-box;
		padding: 6px;
	}

	.top_list {
		padding: 2px 0;
		cursor: pointer;
		user-select: none;
		-webkit-user-select: none;
		-moz-user-select: none;
		-o-user-select: none;
		-ms-user-select: none;
		-webkit-touch-callout: none;
		box-sizing: border-box;
		padding: 2px 4px;
	}

	.top_list_active {
		background-color: #409EFF;
		color: white;
	}
</style>
<script>
	import departmentTree from '@_system/components/formcomponents/common/select/department/tree.vue'
	export default {
		props: {
			id: {
				type: [Number, String],
				default: () => {
					return 0
				}
			},
			staffid: {
				type: Array,
				default: () => {
					return []
				}
			},
			multiple: {
				type: Boolean,
				default: () => {
					return true
				}
			},
		},
		data() {
			return {
				showresignation:false,
				staffloading: false,
				currentdepartmentid: null,
				sourceStaff: {},
				staff: [],
				topListActiveName: 'department',
				data: [],
				postjob: [],
				joblevel: [],
				group: [],
				selectstaff: null
			}

		},

		watch: {
			// topListActiveName(value){
			// 	if(value == 'resignation'){
			// 		this.listStaff(true)
			// 	}
			// }
		},
		computed: {
			systemData() {
				return window.systemData
			}
		},
		created() {

		},
		mounted() {
			this.listStaff()
			this.initTopList()
		},
		methods: {
			getdepartment(id) {
				return window.systemMethods.getdepartment(id)
			},
			initTopList() {
				this.postjob = JSON.parse(JSON.stringify(this.systemData.postjob))
				this.joblevel = JSON.parse(JSON.stringify(this.systemData.joblevel))
				this.group = JSON.parse(JSON.stringify(this.systemData.group))
				this.resignation = [{
					name: '离职',
					active: false
				}]
			},
			topListItemClick(item, index, e) {
				e.stopPropagation()
				this.cleartopList()
				item.active = true
				this.$forceUpdate()
				let staff = []
				this.sourceStaff.forEach((staffitem) => {
					if (Array.isArray(staffitem[this.topListActiveName])) {
						if (staffitem[this.topListActiveName].findIndex((g) => {
								return item.id == g
							}) !== -1) {
							staff.push(staffitem)
						}
					} else {
						if (staffitem[this.topListActiveName] == item.id) {
							staff.push(staffitem)
						}
					}
				})
				this.createStaff(staff)
				//this.currentpostjob = item
			},
			cleartopList() {
				this.postjob.forEach((item) => {
					item.active = false
				})
				this.joblevel.forEach((item) => {
					item.active = false
				})
				this.group.forEach((item) => {
					item.active = false
				})
			},
			listStaff() {
				this.staffloading = true
				if (!window.systemData.staff) {
					this.$api.staff.list({
						currentPage: -1
					}).then((res) => {
						this.sourceStaff = res.list
						this.createStaff(this.sourceStaff)
						this.initValue()
						this.staffloading = false
					})
				} else {
					this.sourceStaff = JSON.parse(JSON.stringify(window.systemData.staff))
					this.createStaff(this.sourceStaff)
					this.initValue()
					this.staffloading = false
				}
			},
			departmentTreeChange(e) {
				this.currentdepartmentid = e
				let staff = []
				//console.log(this.sourceStaff)
				this.sourceStaff.forEach((item) => {
					if (e.children.indexOf(item.departmentid) != -1) {
						staff.push(item)
					}
				})
				this.createStaff(staff)
			},

			createStaff(list) {
				let arr = []
				list.forEach((item) => {
					if (!this.showresignation) {
						if (item.status == 3 && item.enable == 5) {
							arr.push({
								id: item.id,
								name: item.name,
								departmentid: item.departmentid,
								active: false
							})
						}
					} else {
						arr.push({
							id: item.id,
							name: item.name,
							departmentid: item.departmentid,
							active: false
						})
					}

				})
				this.staff = arr

			},
			initValue() {
				this.staffid.forEach((item) => {
					this.staff.forEach((_item) => {
						let exist = false
						if (Array.isArray(item)) {
							let index = item.findIndex((it) => {
								return it == _item.id
							})
							if (index !== -1) {
								exist = _item
							}
						} else {
							if (_item.id == item) {
								exist = _item
							}
						}
						if (exist) {
							let obj = {
								id: exist.id,
								name: exist.name,
								departmentname: this.$refs.authstaffdepartmenttree
									.getdepartmentbyid(
										exist.departmentid).name,
								departmentid: exist.departmentid,
								active: false,
							}
							this.data.push(obj)
						}
					})


				})

			},
			staffItemClick(item, index, e) {
				e.stopPropagation()
				this.clearStaff()
				this.staff[index].active = true
			},
			clearStaff() {
				this.staff.forEach((item) => {
					item.active = false
				})
			},
			getActiveStaff() {
				let obj = null
				this.staff.forEach((item) => {
					if (item.active) {
						obj = item
					}
				})
				return obj
			},
			dataItemClick(item, index, e) {
				e.stopPropagation()
				this.clearDataItem()
				this.data[index].active = true
			},
			clearDataItem() {
				this.data.forEach((item) => {
					item.active = false
				})
			},
			getActiveDataItem() {
				let obj = null
				this.data.forEach((item, index) => {
					if (item.active) {
						obj = {
							item: item,
							index: index
						}
					}
				})
				return obj
			},
			checkDataItemUnique(checkItem) {
				let obj = null
				this.data.forEach((item) => {
					if (item.id == checkItem.id) {
						obj = true
					}
				})
				return obj
			},
			stafselectchange(e) {
				if (e == -1) {
					this.toRight({
						staffid: this.$store.state.system.user.id
					})
				} else {
					this.toRight({
						staffid: e
					})
				}

			},
			toRight(e) {
				let staff = null
				if (!e.staffid) {
					staff = this.getActiveStaff()
				} else {
					staff = this.sourceStaff.find(function(item) {
						return item.id == e.staffid
					})
				}
				if (!staff) {
					if (this.currentdepartmentid) {
						//console.log(this.currentdepartmentid,this.staff)
						staff = this.staff.filter((item) => {
							return this.currentdepartmentid.children.indexOf(item.departmentid) != -1
						})
						staff.forEach((item) => {
							this.addstaff(item)
						})
						//console.log(this.staff)
					}
					// this.$message.error({
					// 	message: '请选择人员',
					// })
				} else {
					this.addstaff(staff)

					//console.log(this.currentdepartmentid,relativep)
				}
			},
			addstaff(staff) {
				let obj = {
					id: staff.id,
					name: staff.name,
					departmentname: this.$refs.authstaffdepartmenttree.getdepartmentbyid(staff.departmentid).name,
					departmentid: staff.departmentid,
					active: false,
				}
				if (!this.checkDataItemUnique(obj)) {
					if (this.multiple) {
						this.data.push(obj)
					} else {
						this.data = []
						this.data.push(obj)
						// if (this.data.length == 0) {
						// 	this.data.push(obj)
						// } else {
						// 	this.$message.error({
						// 		message: '不可多选',
						// 	})
						// }
					}
				} else {
					return
					// this.$message.error({
					// 	message: '该选项已存在',
					// })
				}
			},
			clearselectstaff() {
				this.data = []
			},
			toLeft() {
				let obj = this.getActiveDataItem()
				if (obj) {
					this.data.splice(obj.index, 1)
					this.dataChange()
				}
			},
			submitData() {
				return this.data
			},
			setData(data) {
				data.forEach((item) => {
					item.active = false
				})
				this.data = data
			},
			dataChange() {
				this.$emit('datachange', {
					data: this.data,
					type: 'staff'
				})
			},

			flashAuthList() {
				// console.log(this.data)
				// console.log(this.sourceStaff)
				let data = []
				this.data.forEach((item) => {
					let index = this.sourceStaff.findIndex((_item) => {
						return _item.id == item.id
					})
					if (index !== -1) {
						item.name = this.sourceStaff[index].name
						item.departmentid = this.sourceStaff[index].departmentid
						item.departmentname = this.$refs.authstaffdepartmenttree.getdepartmentbyid(item
							.departmentid).name

						data.push(item)
					}
				})
				this.data = data
			}
		},
		components: {
			departmentTree
		}
	}
</script>